import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Tilt3D from './Tilt3D';

const ServiceCard = ({ title, description, icon: Icon, path = "#", index }) => {
  return (
    <Link to={path} className="block h-full cursor-pointer">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="group relative h-full bg-slate-50 p-4 md:p-7 rounded-xl md:rounded-[1.5rem] border border-slate-100 hover:border-primary/30 transition-all duration-500 overflow-hidden flex flex-col hover:-translate-y-1 shadow-lg shadow-slate-200/50"
      >
        {/* Section Serial Number */}
        <div className="absolute top-3 right-4 md:top-4 md:right-6">
          <span className="text-[8px] md:text-xs font-black text-slate-200 group-hover:text-primary/30 transition-colors tabular-nums">
            {(index + 1).toString().padStart(2, '0')}
          </span>
        </div>

        <div className="relative z-10 flex flex-col h-full">
          {/* Icon Header */}
          <div className="mb-3 md:mb-6">
            <div className="w-8 h-8 md:w-12 md:h-12 bg-white text-primary rounded-lg md:rounded-xl flex items-center justify-center group-hover:bg-primary group-hover:text-white group-hover:scale-105 transition-all duration-500 shadow-md group-hover:shadow-primary/30 border border-slate-100 group-hover:border-primary">
              <Icon className="w-4 h-4 md:w-6 md:h-6" strokeWidth={1.5} />
            </div>
          </div>

          {/* Content */}
          <div className="flex-grow">
            <h3 className="text-[13px] md:text-lg font-black text-slate-900 mb-1 md:mb-2 group-hover:text-primary transition-colors duration-300 tracking-tight leading-tight">
              {title}
            </h3>
            <p className="text-slate-500 leading-tight text-[10px] md:text-sm group-hover:text-slate-700 transition-colors duration-300 font-medium line-clamp-2 md:line-clamp-3">
              {description}
            </p>
          </div>

          {/* Footer Label */}
          <div className="mt-3 pt-2 border-t border-slate-200/60 flex items-center justify-between opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-1 group-hover:translate-y-0">
            <span className="text-[8px] md:text-[10px] font-black uppercase tracking-[0.2em] text-primary">View</span>
            <ArrowUpRight size={12} className="text-primary group-hover:scale-110 transition-transform" />
          </div>
        </div>

        {/* Background Ambient Glow */}
        <div className="absolute -bottom-10 -right-10 w-48 h-48 bg-primary/5 rounded-full blur-[80px] group-hover:bg-primary/10 transition-all duration-700"></div>
      </motion.div>
    </Link>
  );
};

export default ServiceCard;
